import { ADDRESS_CHICAGO, ADDRESS_DC, PHONE_CHICAGO, PHONE_DC } from '@/src/shared/data';

import footerStyle from '../assets/footerStyle';
import logo from '../assets/logobanner';

export const generateHeaderTemplate = style => `
  <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width" />
        <title></title>
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=Lato:400,400i,700,900&display=swap"
        />
        <!-- prettier-ignore -->
        <style>${style}</style>
        <style>${footerStyle}</style>
      </head>
      <body>
      <main>
      <section class="apcia-logo">
        <img src="${logo}" alt="APCIA Logo" width="263">
      </section>
`;

export const generateFooterTemplate = () => `
  </main>
  <footer class="apcia-f1rpim-footer">
    <div class="apcia-xcdwfm-container-lg-Container">
      <div class="apcia-1l1polt-footerWrapper">
        <div class="apcia-1t12z7q-footerAddress">
          <address style="font-style: normal">${ADDRESS_DC}</address><a href="tel:${PHONE_DC}"
            class="apcia-0"><i aria-label="icon: phone" class="anticon anticon-phone apcia-10uv0e0-phoneIcon"><svg
                viewBox="64 64 896 896" focusable="false" class="" data-icon="phone" width="1em" height="1em"
                fill="currentColor" aria-hidden="true">
                <path
                  d="M885.6 230.2L779.1 123.8a80.83 80.83 0 0 0-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L549.8 238.4a80.83 80.83 0 0 0-23.8 57.3c0 21.7 8.5 42.1 23.8 57.4l83.8 83.8A393.82 393.82 0 0 1 553.1 553 395.34 395.34 0 0 1 437 633.8L353.2 550a80.83 80.83 0 0 0-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L123.8 664.5a80.89 80.89 0 0 0-23.8 57.4c0 21.7 8.5 42.1 23.8 57.4l106.3 106.3c24.4 24.5 58.1 38.4 92.7 38.4 7.3 0 14.3-.6 21.2-1.8 134.8-22.2 268.5-93.9 376.4-201.7C828.2 612.8 899.8 479.2 922.3 344c6.8-41.3-6.9-83.8-36.7-113.8z">
                </path>
              </svg></i> ${PHONE_DC}</a>
        </div>
        <div class="apcia-1t12z7q-footerAddress">
          <address style="font-style: normal">${ADDRESS_CHICAGO}</address><a href="tel:${PHONE_CHICAGO}"><i
              aria-label="icon: phone" class="anticon anticon-phone apcia-10uv0e0-phoneIcon"><svg viewBox="64 64 896 896"
                focusable="false" class="" data-icon="phone" width="1em" height="1em" fill="currentColor"
                aria-hidden="true">
                <path
                  d="M885.6 230.2L779.1 123.8a80.83 80.83 0 0 0-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L549.8 238.4a80.83 80.83 0 0 0-23.8 57.3c0 21.7 8.5 42.1 23.8 57.4l83.8 83.8A393.82 393.82 0 0 1 553.1 553 395.34 395.34 0 0 1 437 633.8L353.2 550a80.83 80.83 0 0 0-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L123.8 664.5a80.89 80.89 0 0 0-23.8 57.4c0 21.7 8.5 42.1 23.8 57.4l106.3 106.3c24.4 24.5 58.1 38.4 92.7 38.4 7.3 0 14.3-.6 21.2-1.8 134.8-22.2 268.5-93.9 376.4-201.7C828.2 612.8 899.8 479.2 922.3 344c6.8-41.3-6.9-83.8-36.7-113.8z">
                </path>
              </svg></i> ${PHONE_CHICAGO}</a>
        </div>
      </div>
      <div class="apcia-63jt0d-footerBottom">
        <div class="apcia-1ud9iap-footerCopyright">
          Copyright © ${new Date().getFullYear()} by American Property Casualty Insurance Association
        </div>
      </div>
    </div>
  </footer>
  </body>
  </html>
`;
